import * as React from 'react';
import {Divider, FormControlLabel, Switch} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import {useTranslation} from "react-i18next";
import {convertPrice, handleSetServicesLogo} from "../../assets/js/main";
import {
    setListServices,
    setSelectedServices,
    setServicePriceServices,
    setTotalPriceServices
} from "../../redux/singleOrder/services/actions";
import {useDispatch, useSelector} from "react-redux";
import {setNeedSender} from "../../redux/singleOrder/sender/actions";
import {setFactorBox, setNeedBox} from "../../redux/singleOrder/infoBox/actions";
import HandleFetchData from "../../plugin/HandleFetchData";
import styled from "@emotion/styled";
import {CircleOutlined} from "@mui/icons-material";

// استایل های سفارشی برای سوئیچ اکشن ها
const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))
(({theme}) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                background: '#F7941D',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#F7941D',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: '#fff'
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        background: '#cecece',
        opacity: 1,

    },
}));

export default function Services(props) {
    const {t} = useTranslation();
    const {fetchData} = HandleFetchData()
    const dispatch = useDispatch();
    const selector = useSelector((st) => st)
    const [filter, setFilter] = React.useState('0');
    const [serviceDetails, setServiceDetails] = React.useState();

    const [itemPrice, setItemPrice] = React.useState(null);


    React.useEffect(() => {
        // handleAgentCities()
        handleGetItemPrice()
    }, [])

    React.useEffect(() => {
        if (filter === '0') {
            let sortPrice = selector?.single_services?.listServices?.sort((a, b) => a?.Price - b?.Price)
            dispatch(setListServices(sortPrice))
        } else {
            let sortSLA = selector?.single_services?.listServices?.sort((a, b) => Number(handlerSplitDate(a?.SLA)[1]) - Number(handlerSplitDate(b?.SLA)[1]))
            dispatch(setListServices(sortSLA))
        }
    }, [filter])


    const handlerSplitDate = (e) => {
        return e?.split("|")
    }

    const handleGetItemPrice = async () => {
        let fetch = await fetchData('', 'GET', '/getAddedValueServicePrice', '', "", {
            "ApproximateValue": Number(String(selector?.single_info_box?.price)?.split(',').join('')),
            "CartonSizeName": selector?.single_info_box?.size,
            "InsuranceName": "* انتخاب بیمه ضروری است *",
            "length": selector?.single_info_box?.length,
            "width": selector?.single_info_box?.width,
            "height": selector?.single_info_box?.height,
        }, 'postex')
        setItemPrice(fetch?.data)


        let filter = selector?.single_services?.listServices.filter(e => e.CanSelect === true)
        !selector?.single_services?.selectedService && handleTotalServicePrice(filter[0], fetch?.data)
        !selector?.single_services?.selectedService && handlerSelectService(filter[0])
    }


    const handlerSelectService = (e) => {
        // if (selector?.single_services?.selectedService?.ServiceId === e?.ServiceId) {
        //   // dispatch(setSelectedServices(null))
        //   handleAgentCities()
        // } else {
        //   // dispatch(setSelectedServices(e))
        // }
        dispatch(setNeedSender(e?.CanCollect))
        // handleTotalPrice(e?.CanCollect, e?.CollectionPrice)
        dispatch(setSelectedServices(e))
        // e?.CourierCode && handleCourierCities(e?.CourierCode)
    }

    const handlerServiceDetails = (id) => {
        serviceDetails === id
            ?
            setServiceDetails(null)
            :
            setServiceDetails(id)
    }

    const availableServicesTemplatesDesktop = () => {
        return (
            <>
                <div className="availableServices">
                    <table>
                        <thead>
                        <tr>
                            <th/>
                            <th>{t("singleOrder.serviceType.t7")}</th>
                            <th>{t("singleOrder.serviceType.t8")}</th>
                            <th>{t("singleOrder.serviceType.t30")} ({t("singleOrder.serviceType.t11")})</th>
                            {/*<th>{t("singleOrder.serviceType.t10")}</th>*/}
                        </tr>
                        </thead>
                        <tbody>
                        {selector?.single_services?.listServices?.map((item, index) => {
                            return (
                                process.env.REACT_APP_SITE === 'amnito' ?
                                    (item?.CourierCode === "IR_POST" && item?.CanSelect) &&
                                    <>
                                        <tr key={index}
                                            className={'bodyTable' + " " + (selector?.single_services?.selectedService?.ServiceId === item?.ServiceId ? 'active' : null)}
                                            onClick={() => {
                                                handleTotalServicePrice(item, itemPrice)
                                                handlerSelectService(item)
                                            }}
                                            id="handlerSelectService">
                                            <td>
                                                <div className="icon">
                                                    <img src={handleSetServicesLogo(item?.ServiceName)}
                                                         alt={item?.ServiceName} loading="lazy"/>
                                                    {
                                                        selector?.single_services?.selectedService?.ServiceId === item?.ServiceId
                                                            ?
                                                            <CircleIcon className="check"/>
                                                            :
                                                            <CircleOutlined className="empty"/>
                                                    }
                                                </div>
                                            </td>
                                            <td className="title _title">
                                                {item?.ServiceName}
                                            </td>
                                            <td className="title">{handlerSplitDate(item?.SLA)[0]}</td>
                                            <td className="title _title">{convertPrice(item?.Price)}</td>
                                            {/*<td>*/}
                                            {/*  <div className="details">*/}
                                            {/*    <div className="items-right">*/}
                                            {/*      <div className="item-home">*/}
                                            {/*        <HomeIcon/>*/}
                                            {/*        <span className="desc">{t("singleOrder.serviceType.t12")}:</span>*/}
                                            {/*        <span className="title">{convertPrice(item?.CollectionPrice) || "0"} {t("singleOrder.serviceType.t11")}</span>*/}
                                            {/*      </div>*/}
                                            {/*      <div className="item-location">*/}
                                            {/*        <LocationOnIcon/>*/}
                                            {/*        <span className="desc">{t("singleOrder.serviceType.t13")}:</span>*/}
                                            {/*        <span className="title">{convertPrice(item?.DistributionPrice) || "0"} {t("singleOrder.serviceType.t11")}</span>*/}
                                            {/*      </div>*/}
                                            {/*    </div>*/}
                                            {/*  </div>*/}
                                            {/*</td>*/}
                                        </tr>
                                    </>
                                    :
                                    item?.CanSelect &&
                                    <>
                                        <tr key={index}
                                            className={'bodyTable' + " " + (selector?.single_services?.selectedService?.ServiceId === item?.ServiceId ? 'active' : null)}
                                            onClick={() => {
                                                handleTotalServicePrice(item, itemPrice)
                                                handlerSelectService(item)
                                            }}
                                            id="handlerSelectService">
                                            <td>
                                                <div className="icon">
                                                    <img src={handleSetServicesLogo(item?.ServiceName)}
                                                         alt={item?.ServiceName} loading="lazy"/>
                                                    {
                                                        selector?.single_services?.selectedService?.ServiceId === item?.ServiceId
                                                            ?
                                                            <CircleIcon className="check"/>
                                                            :
                                                            <CircleOutlined className="empty"/>
                                                    }
                                                </div>
                                            </td>
                                            <td className="title _title">
                                                {item?.ServiceName}
                                            </td>
                                            <td className="title">{handlerSplitDate(item?.SLA)[0]}</td>
                                            <td className="title _title">{convertPrice(item?.Price)}</td>
                                            {/*<td>*/}
                                            {/*  <div className="details">*/}
                                            {/*    <div className="items-right">*/}
                                            {/*      <div className="item-home">*/}
                                            {/*        <HomeIcon/>*/}
                                            {/*        <span className="desc">{t("singleOrder.serviceType.t12")}:</span>*/}
                                            {/*        <span className="title">{convertPrice(item?.CollectionPrice) || "0"} {t("singleOrder.serviceType.t11")}</span>*/}
                                            {/*      </div>*/}
                                            {/*      <div className="item-location">*/}
                                            {/*        <LocationOnIcon/>*/}
                                            {/*        <span className="desc">{t("singleOrder.serviceType.t13")}:</span>*/}
                                            {/*        <span className="title">{convertPrice(item?.DistributionPrice) || "0"} {t("singleOrder.serviceType.t11")}</span>*/}
                                            {/*      </div>*/}
                                            {/*    </div>*/}
                                            {/*  </div>*/}
                                            {/*</td>*/}
                                        </tr>
                                    </>
                            )
                        })
                        }
                        </tbody>
                    </table>

                    {
                        !selector?.single_services?.listServices?.some(item => item.CanSelect === true) &&
                        <div className="notFindMessage">
                            <img src={require('./../../assets/img/vector/1.png')} alt="vector" loading="lazy"/>
                            <p>{t("error.t3")}</p>
                        </div>
                    }
                </div>
            </>
        )
    }

    const availableServicesTemplatesMobile = () => {
        return (
            <>
                <div className="availableServices">
                    <table>
                        <thead>
                        <tr>
                            <th/>
                            <th>{t("singleOrder.serviceType.t7")}</th>
                            <th>{t("singleOrder.serviceType.t8")}</th>
                            <th>{t("singleOrder.serviceType.t30")} ({t("singleOrder.serviceType.t11")})</th>
                            {/*<th/>*/}
                        </tr>
                        </thead>
                        <tbody>
                        {selector?.single_services?.listServices?.map((item, index) => {
                            return (
                                process.env.REACT_APP_SITE === 'amnito' ?
                                    (item?.CourierCode === "IR_POST" && item?.CanSelect) && <>
                                        <tr key={index}
                                            className={'bodyTable' + " " + (selector?.single_services?.selectedService?.ServiceId === item?.ServiceId ? 'active' : null)}
                                            onClick={() => {
                                                handleTotalServicePrice(item, itemPrice)
                                                handlerSelectService(item)
                                            }}
                                            id="handlerSelectService">
                                            <td>
                                                <div className="icon">
                                                    <img src={handleSetServicesLogo(item?.ServiceName)}
                                                         alt={item?.ServiceName} loading="lazy"/>
                                                    {
                                                        selector?.single_services?.selectedService?.ServiceId === item?.ServiceId
                                                            ?
                                                            <CircleIcon className="check"/>
                                                            :
                                                            <CircleIcon className="empty"/>
                                                    }
                                                </div>
                                            </td>
                                            <td className="title _title">
                                                <button onClick={() => handlerServiceDetails(item?.ServiceId)}>
                                                    {item?.ServiceName}
                                                    {/*<span className="_bimeh">{t("singleOrder.serviceType.t14")}: {convertPrice(450000)} {t("singleOrder.serviceType.t11")}</span>*/}
                                                </button>
                                            </td>
                                            <td className="title">
                                                <button onClick={() => handlerServiceDetails(item?.ServiceId)}>
                                                    {handlerSplitDate(item?.SLA)[0]}
                                                </button>
                                            </td>
                                            <td className="title _title">
                                                <button onClick={() => handlerServiceDetails(item?.ServiceId)}>
                                                    {convertPrice(item?.Price)}
                                                </button>
                                            </td>
                                            {/*<td className="menu">*/}
                                            {/*  <button onClick={() => handlerServiceDetails(item?.ServiceId)} id="handlerServiceDetails">*/}
                                            {/*    {*/}
                                            {/*      serviceDetails === item?.ServiceId*/}
                                            {/*         ?*/}
                                            {/*         <MoreHorizIcon className="empty"/>*/}
                                            {/*         :*/}
                                            {/*         <MoreVertIcon className="check"/>*/}
                                            {/*    }*/}
                                            {/*  </button>*/}
                                            {/*</td>*/}
                                        </tr>
                                        {/*{*/}
                                        {/*   serviceDetails == item?.ServiceId &&*/}
                                        {/*   <tr className="details-row">*/}
                                        {/*     <td colSpan="5">*/}
                                        {/*       <div className="details">*/}
                                        {/*         <div className="items-right">*/}
                                        {/*           <div className="item-home">*/}
                                        {/*             <HomeIcon/>*/}
                                        {/*             <span className="desc">{t("singleOrder.serviceType.t12")}:</span>*/}
                                        {/*             <span className="title">{convertPrice(item?.CollectionPrice) || "0"} {t("singleOrder.serviceType.t11")}</span>*/}
                                        {/*           </div>*/}
                                        {/*           <div className="item-location">*/}
                                        {/*             <LocationOnIcon/>*/}
                                        {/*             <span className="desc">{t("singleOrder.serviceType.t13")}:</span>*/}
                                        {/*             <span className="title">{convertPrice(item?.DistributionPrice) || "0"} {t("singleOrder.serviceType.t11")}</span>*/}
                                        {/*           </div>*/}
                                        {/*         </div>*/}
                                        {/*         /!*<div className="items-left">*!/*/}
                                        {/*         /!*  <div>*!/*/}
                                        {/*         /!*    <CircleOutlinedIcon/>*!/*/}
                                        {/*         /!*    <span>پرداخت در محل دارد</span>*!/*/}
                                        {/*         /!*  </div>*!/*/}
                                        {/*         /!*  <div>*!/*/}
                                        {/*         /!*    <CircleOutlinedIcon/>*!/*/}
                                        {/*         /!*    <span>بسته قابل ارسال است</span>*!/*/}
                                        {/*         /!*  </div>*!/*/}
                                        {/*         /!*  <div>*!/*/}
                                        {/*         /!*    <CircleOutlinedIcon/>*!/*/}
                                        {/*         /!*    <span>حداکثر سقف بیمه: 45.0000 ریال</span>*!/*/}
                                        {/*         /!*  </div>*!/*/}
                                        {/*         /!*</div>*!/*/}
                                        {/*       </div>*/}
                                        {/*     </td>*/}
                                        {/*   </tr>*/}
                                        {/*}*/}
                                    </>
                                    :
                                    item?.CanSelect && <>
                                        <tr key={index}
                                            className={'bodyTable' + " " + (selector?.single_services?.selectedService?.ServiceId === item?.ServiceId ? 'active' : null)}
                                            onClick={() => {
                                                handleTotalServicePrice(item, itemPrice)
                                                handlerSelectService(item)
                                            }}
                                            id="handlerSelectService">
                                            <td>
                                                <div className="icon">
                                                    <img src={handleSetServicesLogo(item?.ServiceName)}
                                                         alt={item?.ServiceName} loading="lazy"/>
                                                    {
                                                        selector?.single_services?.selectedService?.ServiceId === item?.ServiceId
                                                            ?
                                                            <CircleIcon className="check"/>
                                                            :
                                                            <CircleIcon className="empty"/>
                                                    }
                                                </div>
                                            </td>
                                            <td className="title _title">
                                                <button onClick={() => handlerServiceDetails(item?.ServiceId)}>
                                                    {item?.ServiceName}
                                                    {/*<span className="_bimeh">{t("singleOrder.serviceType.t14")}: {convertPrice(450000)} {t("singleOrder.serviceType.t11")}</span>*/}
                                                </button>
                                            </td>
                                            <td className="title">
                                                <button onClick={() => handlerServiceDetails(item?.ServiceId)}>
                                                    {handlerSplitDate(item?.SLA)[0]}
                                                </button>
                                            </td>
                                            <td className="title _title">
                                                <button onClick={() => handlerServiceDetails(item?.ServiceId)}>
                                                    {convertPrice(item?.Price)}
                                                </button>
                                            </td>
                                            {/*<td className="menu">*/}
                                            {/*  <button onClick={() => handlerServiceDetails(item?.ServiceId)} id="handlerServiceDetails">*/}
                                            {/*    {*/}
                                            {/*      serviceDetails === item?.ServiceId*/}
                                            {/*         ?*/}
                                            {/*         <MoreHorizIcon className="empty"/>*/}
                                            {/*         :*/}
                                            {/*         <MoreVertIcon className="check"/>*/}
                                            {/*    }*/}
                                            {/*  </button>*/}
                                            {/*</td>*/}
                                        </tr>
                                        {/*{*/}
                                        {/*   serviceDetails == item?.ServiceId &&*/}
                                        {/*   <tr className="details-row">*/}
                                        {/*     <td colSpan="5">*/}
                                        {/*       <div className="details">*/}
                                        {/*         <div className="items-right">*/}
                                        {/*           <div className="item-home">*/}
                                        {/*             <HomeIcon/>*/}
                                        {/*             <span className="desc">{t("singleOrder.serviceType.t12")}:</span>*/}
                                        {/*             <span className="title">{convertPrice(item?.CollectionPrice) || "0"} {t("singleOrder.serviceType.t11")}</span>*/}
                                        {/*           </div>*/}
                                        {/*           <div className="item-location">*/}
                                        {/*             <LocationOnIcon/>*/}
                                        {/*             <span className="desc">{t("singleOrder.serviceType.t13")}:</span>*/}
                                        {/*             <span className="title">{convertPrice(item?.DistributionPrice) || "0"} {t("singleOrder.serviceType.t11")}</span>*/}
                                        {/*           </div>*/}
                                        {/*         </div>*/}
                                        {/*         /!*<div className="items-left">*!/*/}
                                        {/*         /!*  <div>*!/*/}
                                        {/*         /!*    <CircleOutlinedIcon/>*!/*/}
                                        {/*         /!*    <span>پرداخت در محل دارد</span>*!/*/}
                                        {/*         /!*  </div>*!/*/}
                                        {/*         /!*  <div>*!/*/}
                                        {/*         /!*    <CircleOutlinedIcon/>*!/*/}
                                        {/*         /!*    <span>بسته قابل ارسال است</span>*!/*/}
                                        {/*         /!*  </div>*!/*/}
                                        {/*         /!*  <div>*!/*/}
                                        {/*         /!*    <CircleOutlinedIcon/>*!/*/}
                                        {/*         /!*    <span>حداکثر سقف بیمه: 45.0000 ریال</span>*!/*/}
                                        {/*         /!*  </div>*!/*/}
                                        {/*         /!*</div>*!/*/}
                                        {/*       </div>*/}
                                        {/*     </td>*/}
                                        {/*   </tr>*/}
                                        {/*}*/}
                                    </>
                            )
                        })

                        }
                        </tbody>
                    </table>

                    {
                        !selector?.single_services?.listServices?.some(item => item.CanSelect === true) &&
                        <div className="notFindMessage">
                            <img src={require('./../../assets/img/vector/1.png')} alt="vector" loading="lazy"/>
                            <p>{t("error.t3")}</p>
                        </div>
                    }
                </div>
            </>
        )
    }

    const unavailableServicesTemplates = () => {
        return (
            <>
                <div className="unavailableServices">
                    <table>
                        <thead>
                        <tr>
                            <th/>
                            <th>{t("singleOrder.serviceType.t7")}</th>
                            <th>{t("singleOrder.serviceType.t10")}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {selector?.single_services?.listServices?.map((item, index) => {
                            return (
                                !item?.CanSelect && <>
                                    <tr key={index}>
                                        <td>
                                            <div className="icon">
                                                <img src={handleSetServicesLogo(item?.ServiceName)}
                                                     alt={item?.ServiceName} loading="lazy"/>

                                                {/*<CircleIcon className="empty"/>*/}
                                            </div>
                                        </td>
                                        <td className="title">{item?.ServiceName}</td>
                                        <td className="description">{item?._Price === "0" ? t("singleOrder.serviceType.t27") : item?._Price}</td>
                                    </tr>
                                </>
                            )
                        })
                        }
                        </tbody>
                    </table>
                </div>
            </>
        )
    }

    const handleTotalPrice = (e, p) => {
        if (e) {
            dispatch(setTotalPriceServices(selector?.single_services?.totalPrice + p))
        } else {
            dispatch(setTotalPriceServices(selector?.single_services?.totalPrice - p))
        }
    }

    const handleTotalServicePrice = (e, i) => {
        dispatch(setTotalPriceServices(
            Number(e?.Price) +
            (selector?.single_sender?.need ? Number(e?.CollectionPrice) : 0) +
            (((e?.ServiceName == "پس کرایه پیشتاز" || e?.ServiceName == "پس کرایه پستبار اکسپرس") && selector?.single_info_box?.payment_type === 'cod') ? Number(i?.CodTranPrice) : 0) +
            (selector?.single_info_box?.need ? Number(i?.CartonPrice) : 0)
        ))
        dispatch(setServicePriceServices(Number(e?.Price) + (selector?.single_sender?.need ? Number(e?.CollectionPrice) : 0)))
    }


    return (
        <>
            <div className="servicesPage">

                {
                    Number(selector?.single_services?.totalPrice) > 0 &&
                    <div className="totalPrice">
                        <div>
                            <h5>{t("singleOrder.serviceType.t17") + ': '}</h5>
                            <h4>{convertPrice(selector?.single_services?.totalPrice) + ' ' + t("singleOrder.serviceType.t11")}</h4>
                        </div>

                        <Divider/>

                        <p>{t("singleOrder.serviceType.t29") + ': ' + selector?.single_services?.selectedService?.ServiceName}</p>

                        <Divider/>
                    </div>
                }


                <div className="headerPage titleSection">
                    <h4 className="">{t("singleOrder.serviceType.t1")}</h4>
                </div>
                <div className="bodyPage">
                    <div className="d-block d-lg-none" ref={props.serviceSingleRef}>
                        {selector?.single_services?.listServices.filter(e => e.CanSelect).length > 0 ? availableServicesTemplatesMobile() : unavailableServicesTemplates()}
                    </div>

                    <div className="row d-none d-lg-flex" ref={props.serviceSingleRef1}>
                        <div className="col-12">
                            {selector?.single_services?.listServices.filter(e => e.CanSelect).length > 0 ? availableServicesTemplatesDesktop() : unavailableServicesTemplates()}
                        </div>
                    </div>

                </div>

                <Divider/>

                <div className="row">
                    <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                        <div className="item-switch">
                            <FormControlLabel
                                control={<IOSSwitch sx={{m: 1}} checked={selector?.single_info_box?.need}
                                                    onChange={(e) => {
                                                        dispatch(setNeedBox(e.target.checked))
                                                        handleTotalPrice(e.target.checked, (itemPrice?.CartonPrice))
                                                    }}
                                />}
                                label=""/>
                            <p>
                                {t("singleOrder.packageInfo.t6")}
                                <br/>
                                <span className="price">
                   {
                       convertPrice(itemPrice?.CartonPrice) + ' ' + t("singleOrder.serviceType.t11")
                   }
                 </span>
                            </p>

                        </div>
                    </div>

                    <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                        <div className="item-switch">
                            <FormControlLabel
                                disabled={selector?.single_info_box?.need}
                                control={<IOSSwitch sx={{m: 1}}
                                                    checked={selector?.single_info_box?.need || selector?.single_info_box?.factor}
                                                    onChange={(e) => dispatch(setFactorBox(e.target.checked))}
                                />}
                                label=""/>
                            <p>
                                {t("dashboard.setting.t3")}
                            </p>
                        </div>
                    </div>

                    <div className="col-12 col-md-8 mb-4 d-flex flex-wrap">
                        {!selector?.single_services?.selectedService?.HideCollect &&
                            <div className="item-switch _item-switch">
                                <FormControlLabel
                                    disabled={!selector?.single_services?.selectedService?.CanCollect}
                                    control={<IOSSwitch sx={{m: 1}}
                                                        checked={selector?.single_services?.selectedService?.CanCollect && selector?.single_sender?.need}
                                                        onChange={(e) => {
                                                            dispatch(setNeedSender(e.target.checked))
                                                            handleTotalPrice(e.target.checked, selector?.single_services?.selectedService?.CollectionPrice)
                                                        }}
                                    />}
                                    label=""/>
                                <p>
                                    {t("singleOrder.serviceType.t18")}
                                    <br/>
                                    <span className="price">
                                        {t("singleOrder.serviceType.t20")}:
                                        {
                                            (convertPrice(selector?.single_services?.selectedService?.CollectionPrice) || t("singleOrder.serviceType.t1")) + ' ' + (selector?.single_services?.selectedService?.CollectionPrice ? t("singleOrder.serviceType.t11") : '')
                                        }
                                </span>
                                </p>
                            </div>

                        }
                        {(selector?.single_services?.selectedService?.CanCollect && selector?.single_sender?.need) ? <>
                                <div className="mx-3 collection-text"
                                     dangerouslySetInnerHTML={{__html: t("singleOrder.serviceType.t19")}}/>
                            </>
                            : !selector?.single_services?.selectedService?.CanCollect ?
                                <p className="mx-3 mb-0">{t("singleOrder.serviceType.t33")}</p>
                                :
                                <div className="mx-3 collection-text"
                                     dangerouslySetInnerHTML={{__html: t("singleOrder.serviceType.t19")}}/>
                        }

                    </div>
                </div>
            </div>
        </>
    )
}
